/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_Account_NumberInputs */

const vi_payment_qr_account_number = /** @type {(inputs: Payment_Qr_Account_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tài khoản`)
};

/**

* @param {Payment_Qr_Account_NumberInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_account_number = /** @type {((inputs?: Payment_Qr_Account_NumberInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_Account_NumberInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_account_number(inputs)
});